import HBModal from "../HBModal";
import ModalWrap from "../HBModal/ModalWrap";
import styles from "./index.module.less";
import { SHORTCUT_GROUP_LIST } from "@/constants/shortcut";
import Shortcut from "./Shortcut";

function ShortcutModal(props) {
  return (
    <HBModal
      className={styles.modal}
      title="快捷键说明"
      footer={null}
      width={480}
      {...props}
    >
      <Shortcut data={SHORTCUT_GROUP_LIST} />
    </HBModal>
  );
}

export default ModalWrap(ShortcutModal);
